import { useMemo } from 'react';
import type { Client } from '@api';
import { resolveClientPersona } from './resolveClientPersona';
import type { ClientPersonaResolution } from './resolveClientPersona';

/**
 * Handledarens vy av en KLIENTS persona. Till skillnad från useActivePersona
 * (som resolvar BRUKARENS egen vy och alltid ger 'adult' i handledarläge) läser
 * denna klientens persona ur SupervisorConnection.client.persona (BACKEND-
 * KONTRAKT p.4). Belöningsadmin ska gata på detta, inte på handledarens persona.
 *
 * Rent deriverad från propen — memoiseras på client.persona. Ingen 'storage'-
 * lyssnare behövs: klienten byts via SupervisorContext.setClient, som ger en ny
 * currentClient och därmed en ny render.
 */
export const useClientPersona = (currentClient?: Client): ClientPersonaResolution =>
  useMemo(() => resolveClientPersona(currentClient?.persona), [currentClient?.persona]);

export default useClientPersona;
